import React, { Component } from 'react';
import i18next from 'i18next';
import { Stack } from '@mui/material';
import logger from '../utils/logger';

export class ErrorBoundary extends Component<
    Record<string, unknown>,
    { hasError: boolean }
> {
    children: any;

    constructor(props: Record<string, unknown>) {
        super(props);
        this.children = props.children;
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        logger.error(error.message, error.stack);
    }

    render() {
        const { hasError } = this.state;
        if (hasError) {
            return (
                <Stack
                    height="100vh"
                    width="100vw"
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                >
                    <h1
                        style={{
                            fontSize: '25px',
                            width: '300px',
                            textAlign: 'center',
                        }}
                    >
                        {i18next.t('product.noService')}
                    </h1>
                </Stack>
            );
        }
        return this.children;
    }
}
